import styled from 'styled-components'
import { space, layout, color, border } from 'styled-system'

import { FlexDiv, } from 'components/generic/HomePageComponents'

export const PHover = styled.p`
  color: ${(props) => props.theme.colors.inverseColor};
  line-height: 20px;
  font-weight: bold;
  font-size: 14px;
  text-decoration: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
  ${space}
`
export const LargeSearchContentContainer = styled(FlexDiv)`
  background-color: white;
  height: fit-content;
  width: fit-content;
  padding: 0px 20px 20px;
  border: 1px ${(props) => props.theme.colors.grey} solid;
  flex-direction: column;
  justify-content: flex-start;
`
export const StyledInput = styled.input`
  margin-bottom: 8px;
`
export const StylizedA = styled.a`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textColor};
  text-decoration: none;
  padding: 0px 5px;
  margin: 3px 0px;
  cursor: default;
  :visited {
    text-decoration: none;
  }
  ${color}
  ${space}
`

export const StyledFacet = styled.span`
  padding-right: 5px;
  margin-bottom: 8px;
  text-decoration: none;
  path {
    stroke-linecap: round;
  }
  ${StylizedA}:active {  /* stylelint-disable-line selector-type-no-unknown */
    color: ${(props) => props.theme.colors.inverseColor};
  }
`

export const FacetText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: ${(props) => (props.checked ? 'fit-content' : '150px')};
  vertical-align: middle;
`

export const FacetCountBadge = styled.div`
  display: inline-block;
  min-width: 30px;
  margin-top: 1px;
  margin-left: 4px;
  border-radius: 16px;
  background-color: ${(props) => props.theme.colors.textColor};
  color: ${(props) => props.theme.colors.mainColor};
  font-size: 12px;
  font-weight: bold;
  vertical-align: baseline;
  text-align: center;
  white-space: nowrap;
  float: right;
`

export const SmallSearchContentContainer = styled(FlexDiv)`
  background-color: white;
  height: fit-content;
  padding-bottom: 24px;
  padding-right: 8px;
  padding-left: 8px;
  border-radius: 5px;
  border-left: 1px ${(props) => props.theme.colors.grey} solid;
  border-right: 1px ${(props) => props.theme.colors.grey} solid;
  border-bottom: 1px ${(props) => props.theme.colors.grey} solid;
  flex-direction: column;
  justify-content: flex-start;
  display: ${(props) => props.isShown ? 'flex' : 'none'};
`

export const LocationContainerDiv = styled.div`
  display: flex;
  border-radius: 5px;
  border: 1px ${(props) => props.theme.colors.borderColor} solid;
  height: 34px;
  justify-content: space-between;
  margin: 4px 0px;
  background-color: white;
  cursor: pointer;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.lightGrey};
  }
  :active {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.lightGrey};
  }
  ${space}
  ${layout}
`

export const DropDownButton = styled.a`
  text-decoration: none; 
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  padding: 10px 10px 10px 10px;
  line-height: 1.428571429;
  user-select: none;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: ${(props) => (props.showDropDown ? '0px' : '5px')};
  border-bottom-right-radius: ${(props) => (props.showDropDown ? '0px' : '5px')};
  border-top: 1px ${(props) => props.theme.colors.grey} solid;
  border-bottom: 1px ${(props) => (props.showDropDown ? 'none' : '#f2f2f2 solid')};
  border-left: 1px ${(props) => props.theme.colors.grey} solid;
  border-right: 1px ${(props) => props.theme.colors.grey} solid;
  color: ${(props) => props.theme.colors.textColor};
  font-weight: bold;
  :hover {
    background-color: white;
    transition: all 0.2s ease-in-out;
  }
`

export const KeywordSearchButton = styled.a`
  width: 34px;
  height: 34px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.textColor};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DropdownCenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: inherit;
  margin-left: 8px;
  cursor: pointer;
`

export const DropDownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  ${space}
  ${layout}
`

export const LocationDropdownAnchor = styled.a`
  height: 100%;
  text-decoration: none;
  color: ${(props) => props.theme.colors.darkGrey};
  padding: 1px 2px 2px 16px;
  line-height: 21px;
  font-size: 14px;
  :active {
    background-color: ${(props) => props.theme.colors.dropdownLightGrey};
  }
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.dropdownLightGrey};
  }
  ${space}
  ${layout}
`

export const DropButton = styled.div`
  color: ${(props) => props.theme.colors.darkGrey};
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
`

export const DropdownButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  :active {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.lightGrey};
  }
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.lightGrey};
  }
`

export const DropdownButtonPostalCode = styled.div`
  display: inline-block;
  flex-direction: column;
  text-align: center;
  position:relative;
  height: -webkit-fill-available;
  width: 100%;
  white-space: nowrap;
  padding-top: 8px;
  ${(props) => props.clickable ? `` : `user-select: none;`};
  ${(props) => props.clickable ? `` : `opacity: 0.5`};
  :active {
    ${(props) => (props.clickable ? `background-color: ${(props) => props.theme.colors.lightGrey};` : '')};
  }
  :hover {
    ${(props) => (props.clickable ? `cursor: pointer;` : ``)};
    ${(props) => (props.clickable ? `background-color: ${(props) => props.theme.colors.lightGrey};` : '')};
  }
`

export const DropdownContent = styled.div`
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  width: 216px;
  padding-right: 4px;
  z-index: 1;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px ${(props) => props.theme.colors.borderColor} solid;
  flex-direction: row;
  left: -8px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(102,175,233,0.6);
  ${(props) => (props.showDropdown ? `display: flex;` : ` display: none;`)};
  ${space} 
  ${border}
`
export const Dropdown = styled.div`
  height: 95%;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  ${space}
`

export const StyledDropdownAnchorContainer = styled.div`
  display: flex;
  width: calc(100% + 4px);
  color: ${(props) => props.theme.colors.darkGrey};
  overflow-x: auto;
  cursor: pointer;
  :active {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.dropdownLightGrey};
  }
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.dropdownLightGrey};
  }
`

export const DropdownFilterInput = styled.input`
  border-radius: 4px;
  align-self: center;
  display: flex;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  width: 90%;
  height: 24px;
  margin-left: 4px;
  margin-top: 4px;
  margin-bottom: 4px;
  color: ${(props) => props.theme.colors.dropdownFilterColor};
  font-size: 14px;
  padding-left: 8px;
  :focus {
    outline: none;
  }
  ${space}
  ${layout}
  ${border}
`

export const AnchorsContainer = styled.div`
  max-height: 220px;
  width: calc(100% + 4px);
  overflow-x: hidden;
  overflow-y: auto;
`

export const FacetDropdownContainer = styled.div`
  display: flex;
  border-radius: 5px;
  border: 1px ${(props) => props.theme.colors.borderColor} solid;
  height: 34px;
  justify-content: space-between;
  margin: 4px 0px 8px 0px;
  background-color: white;
  ${(props) => (props.showDropdown ? `box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(102,175,233,0.6);` : `none;`)};
  ${border}
`

export const FacetDropdownButton = styled(DropButton)`
  font-weight: normal;
`

export const FacetDropdownAnchor = styled.a`
  height: 100%;
  text-decoration: none;
  color: ${(props) => props.theme.colors.darkGrey};
  padding: 1px 0px 1px 16px;
  font-size: 14px;
  :active {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.facetDropdownHoverColor};
  }
  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.facetDropdownHoverColor};
  }
  ${space}
  ${layout}
`

export const FacetAnchorContainer = styled.div`
  display: flex;
  width: calc(100% + 4px);
  padding-top: 6px;
  padding-bottom: 6px;
  color: ${(props) => props.theme.colors.darkGrey};
  :hover {
    background-color: ${(props) => props.theme.colors.facetDropdownHoverColor};
    ${FacetDropdownAnchor} {
      color: ${(props) => props.theme.colors.white};
    }
  }
`

export const FacetAnchorTitle = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textColor};
  text-decoration: none;
  cursor: default;
  margin: 0px 0px 2px 2px;
  padding: 0;
`
export const DropdownDistance = styled.a`
  font-size: 13px;
  color: #808284;
  font-family: 'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
`

export const PostalInput = styled.input`
  font-family: 'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  border-radius: 5px 0px 0px 5px;
  color: #808284;
  border: ${(props) => props.invalidPostalCode ? '#A80B0B solid' : '#ccc solid' };
  border-width: ${(props) => props.invalidPostalCode ? '2px' : '0px 2px 0px 0px' };
  padding-left: 10px;
  width: 90%;
  opacity: 90%;
  :focus {
    outline: none;
    border-color: ${(props) => props.invalidPostalCode ? '#A80B0B' : '' };
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);
  }
`

export const PostalCodeErrorContainer = styled.div`
  display: block;
  width: ${['', '', '220px']};
  color: #A80B0B;
  font-size: 14px;
  margin-top: 11px;
  line-height: 16px;
  vertical-align: center;
`

export const PostalContent = styled.div`
  position: absolute;
  background-color: #fff;
  min-width: 95%;
  width: fit-content;
  padding-right: 4px;
  z-index: 1;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px ${(props) => props.theme.colors.borderColor} solid;
  flex-direction: row;
  display: block;
  ${space} 
`